import React from 'react';
import { Link } from 'react-router-dom';
import { useInView } from 'react-intersection-observer';
import { Layers, ArrowLeft } from 'lucide-react';
import useServices from '../utils/useServices';
import { getServiceColor, getServiceIcon } from '../utils/servicePresentation';

const ServicesSection = () => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });
  const { services } = useServices();

  return (
    <section className="section-padding" ref={ref}>
      <div className="container-custom mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-orvix-primary/10 border border-orvix-primary/20 text-orvix-primary text-sm font-medium mb-6">
            <Layers size={16} />
            <span>خدماتنا</span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            حلول <span className="gradient-text">متكاملة</span> لأعمالك
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto">خدماتنا تُدار بالكامل من لوحة التحكم، لتحديث الأنشطة والحلول المعروضة بالموقع في أي وقت.</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => {
            const Icon = getServiceIcon(service.iconKey);
            const color = getServiceColor(service.colorKey);
            return (
              <div
                key={service._id || index}
                className={`glass p-8 hover:bg-white/10 transition-all duration-500 group ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <div className="flex items-center justify-between gap-3 mb-6">
                  <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${color.gradient} flex items-center justify-center group-hover:scale-110 transition-transform`}>
                    <Icon className="w-7 h-7 text-white" />
                  </div>
                  {service.category && <span className={`px-2.5 py-1 rounded-lg border text-xs ${color.badge}`}>{service.category}</span>}
                </div>
                <h3 className="text-xl font-bold text-white mb-3">{service.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed mb-4 min-h-[72px]">{service.description}</p>
                <Link to="/services" className="inline-flex items-center gap-2 text-orvix-green text-sm font-medium hover:gap-3 transition-all">
                  اكتشف المزيد <ArrowLeft size={16} />
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
